import { DatePipe } from '@angular/common';
import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedidos-todos',
  templateUrl: './pedidos-todos.component.html',
  styleUrls: ['./pedidos-todos.component.scss']
})
export class PedidosTodosComponent {
  rows: Array<any>;
  estados: Array<any>;
  filterForm: FormGroup;
  isLoading: boolean = false;
  bsRangeValue: Date[];

  constructor(
    public generalService: GeneralService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    public Func: FechaFunctionsService) {
  }

  async ngOnInit() {
    this.loadingService.setLoading(true)
    try {
      this.initializeForm();
      this.bsRangeValue = [this.Func.addDays(this.Func.Today(), -30), this.Func.Today()]
      const datepipe: DatePipe = new DatePipe('en-US')
      this.filterForm.get('fechaIngresoTo').setValue(datepipe.transform(this.Func.addDays(this.Func.Today(), -30).toISOString(), 'dd/MM/yyyy'));
      this.filterForm.get('fechaIngresoFrom').setValue(datepipe.transform(this.Func.Today().toISOString(), 'dd/MM/yyyy'));
      await Promise.all([
        this.getEstados(),
        this.getData()
      ]);
    } catch (error) {
      console.log(error)
      this.loadingService.setLoading(false)
    } finally {
      this.loadingService.setLoading(false)
    }
  }

  initializeForm() {
    this.filterForm = this.fb.group({
      fechaIngresoTo: [null],
      fechaIngresoFrom: [null],
      fechaEntregaTo: [null],
      fechaEntregaFrom: [null],
      estado: [null],
      includeEntregados: [null]
    });
  }

  async getData() {
    this.isLoading = true;
    try {
      let queryParam: string = "?";
      if (this.filterForm.get('fechaIngresoTo').value) queryParam = queryParam + `fecha_ingreso_to=${this.filterForm.get('fechaIngresoTo').value}&`;
      if (this.filterForm.get('fechaIngresoFrom').value) queryParam = queryParam + `fecha_ingreso_from=${this.filterForm.get('fechaIngresoFrom').value}&`;
      if (this.filterForm.get('fechaEntregaTo').value) queryParam = queryParam + `fecha_termino_to=${this.filterForm.get('fechaEntregaTo').value}&`;
      if (this.filterForm.get('fechaEntregaFrom').value) queryParam = queryParam + `fecha_termino_from=${this.filterForm.get('fechaEntregaFrom').value}&`;
      if (this.filterForm.get('estado').value && this.filterForm.get('estado').value != "null") queryParam = queryParam + `id_estado=${this.filterForm.get('estado').value}&`;
      let res = await this.generalService.getListar(`pedido/todo${queryParam}`)
      this.rows = res.data;
    } catch (error) {
      console.log(error)
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  }

  async getEstados() {
    try {
      let res = await this.generalService.getListar("estado")
      this.estados = res.data;
    } catch (error) {
      console.log(error)
    }
  }
}
